import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { useFormikContext } from 'formik'
import LiquidCheckbox from '@src/components/LiquidCheckbox'
import {
  SemiConfigFormValues,
  SemiConfigClone,
  useProductFromQueryParam,
  getProductBasedUniqueIdName,
} from '../../ProductsConfiguration'

const useStyles = makeStyles()((theme) => ({
  checkbox: {
    paddingLeft: theme.spacing(4),
  },
}))

interface SelectSingleCheckboxProps {
  clone: SemiConfigClone
}
const SelectSingleCheckbox: React.FC<SelectSingleCheckboxProps> = ({
  clone,
}) => {
  const { classes } = useStyles()
  const formik = useFormikContext<SemiConfigFormValues>()
  const product = useProductFromQueryParam()
  const uniqueIdName = getProductBasedUniqueIdName(product)

  const handleSelectSingle: React.ChangeEventHandler<HTMLInputElement> = () => {
    if (!uniqueIdName) return
    const existingClones = [...formik.values.selectedClones]
    if (
      existingClones.find((data) => data[uniqueIdName] === clone[uniqueIdName])
    )
      formik.setFieldValue(
        'selectedClones',
        existingClones.filter(
          (data) => data[uniqueIdName] !== clone[uniqueIdName]
        ),
        false
      )
    else
      formik.setFieldValue('selectedClones', [...existingClones, clone], false)
  }
  const checkForSelected = !!formik.values.selectedClones.find(
    (data) => data[uniqueIdName] === clone[uniqueIdName]
  )

  return (
    <div className={classes.checkbox}>
      <LiquidCheckbox
        onChange={handleSelectSingle}
        checked={checkForSelected}
      />
    </div>
  )
}
export default SelectSingleCheckbox
